import type { PropsWithChildren } from 'react';

import {
  GlobalApiInstitutionDetailsContextProvider,
  useGlobalApiInstitutionDetailsContext,
} from '@state/checkout-contexts';
import { CURRENT_SERVICE_TYPE, SERVICE_TYPE } from '@utility/checkout-utils';

import { useJwtContext } from '../../hooks/useJwtContext/useJwtContext';

export const useInstitutionDetailsContext = () => {
  const { institutionDetails, isLoading } =
    useGlobalApiInstitutionDetailsContext();

  return {
    bankName: institutionDetails?.name,
    logoUrl: institutionDetails?.assets?.logo ?? undefined,
    iconUrl: institutionDetails?.assets?.icon ?? undefined,
    countryCode: institutionDetails?.country,
    isInstitutionDataLoading: isLoading || !institutionDetails,
  };
};

export const InstitutionDetailsContextProvider = ({
  children,
}: PropsWithChildren) => {
  const { token: authToken, payload } = useJwtContext();

  return (
    <GlobalApiInstitutionDetailsContextProvider
      institutionId={payload?.institutionId ?? ''}
      authToken={authToken ?? ''}
      institutionsList={[]}
      skip={!authToken || !payload?.institutionId}
      voltService={CURRENT_SERVICE_TYPE === SERVICE_TYPE.AIS ? 'ais' : 'pis'}
      voltApp="scaApp"
    >
      {children}
    </GlobalApiInstitutionDetailsContextProvider>
  );
};

export const withInstitutionDetailsContextProvider = ({
  children,
}: PropsWithChildren) => (
  <InstitutionDetailsContextProvider>
    {children}
  </InstitutionDetailsContextProvider>
);
